const FAQHeroSection = $('#hero-section');

const addFAQHeroIn = () => {
  const heroDescription = FAQHeroSection.find('.hero-section-descriptor');
  const heroTitle = FAQHeroSection.find('.hero-section-title');
  const searchParent = $('.faq-search-parent');
  const menuParent = $('.list-float-menu');
  const listParent = $('.faq-list-parent');

  const heroTL = gsap.timeline({
    paused: true,
    onComplete: () => {
      $(window).trigger('heroReady');
    },
  });

  heroTL.addLabel('step1');
  heroTL.add(addBigTitleAnimation(heroTitle, 150, 0.9, 0.15).play(), 'step1+=0.5');
  heroTL.add(addElementInAnimation(heroDescription, '1000%', 0.9, 0).play(), 'step1+=0.5');
  heroTL.add(addElementInAnimation(searchParent, '12.5vw', 0.9, 0).play(), 'step1+=0.8');
  heroTL.add(addElementInAnimation(menuParent, '12.5vw', 0.9, 0).play(), 'step1+=0.9');
  heroTL.add(addElementInAnimation(listParent, '12.5vw', 0.9, 0).play(), 'step1+=1');
  //heroTL.add(addBtnAnimation(heroBtn).play(), 'step1+=1.5');
  heroTL.add(headerAnimation(true, 0.6, 0.01).play(), 'step1+=2.13');

  return heroTL;
};

$(window).on('load', () => {
  const [nav] = performance.getEntriesByType('navigation');
  const FAQHeroTL = addFAQHeroIn();
  pageIn(FAQHeroTL, nav);
});
